import React from 'react'
import { State } from '../../../cmsPage.widget'
import { SharedBlockLayout } from '../shared/sharedBlock.layout'
import { CookieBlockClassNames, CookieBlockProps } from './cookieBlock.state'
import { fromJSX, Widget, Updater } from 'widgets-for-react'
import i18next from 'i18next'
import { getClassNameModern } from '../../../../../../Shared/Frontend/utils/getClassNameFromStyle'
import { slugify } from '../../../../../../Shared/Frontend/utils/slugify'
import { htmlDecode } from '../../../utils/html'


export const cookieBlockClasses: CookieBlockClassNames = {
  // DEFAULTS
  block: 'block block--text',
  inview: 'inview',
  inner: 'block__inner ls-container ls-gutter ls-spacing--s',
  header: 'block__header',
  label: 'block__label text--s',
  title: 'block__title title--m',
  intro: 'block__intro text--l',
  content: 'block__content',
  text: 'block__text text--styled',
  footer: 'block__footer ls-clickables',
  clickableWrapper: 'block__action ls-clickable',
  clickablePrimary: 'block__button button button--primary',
  clickableSecondary: 'block__button button button--tertiary',
}

export function CookieBlockLayout(props: CookieBlockProps, rootState: State): Widget<Updater<State>> {
  // Looks the same as the textBlock
  // Primary action triggers the CookieBar

  const { label, title, intro, text, } = props

  return fromJSX((setState) => {
    return (
      <>
        {
          (label || title || intro) && (
            <header className={getClassNameModern(cookieBlockClasses, 'header', '')}>
              {label &&
                <p className={getClassNameModern(cookieBlockClasses, 'label', 'fs-6 text-primary text-uppercase')}>{label}</p>
              }
              {title &&
                <h2 id={slugify(htmlDecode(title))} className={getClassNameModern(cookieBlockClasses, 'title', 'h2 mb-3')}>{title}</h2>
              }
              {intro &&
                <p
                  className={getClassNameModern(cookieBlockClasses, 'intro', 'text--styled mb-3')}
                  dangerouslySetInnerHTML={{ __html: intro }}
                />
              }
            </header>
          )
        }
        {
          text && (
            <div className={getClassNameModern(cookieBlockClasses, 'content', '')}>
              <div
                className={getClassNameModern(cookieBlockClasses, 'text', 'text--styled')}
                dangerouslySetInnerHTML={{ __html: text }}
              />
            </div>
          )
        }
        <footer className={getClassNameModern(cookieBlockClasses, 'footer', 'pt-5')}>
          <div className={getClassNameModern(cookieBlockClasses, 'clickableWrapper', 'd-block d-sm-inline-block')}>
            <button
              id='cookieTextPrimaryAction'
              onClick={() => setState((s1) => {
                return {
                  ...s1,
                  cookiebarState: {
                    ...s1.cookiebarState,
                    ExpandOptions: false,
                    CookieBarVisible: true
                  }
                }
              })}
              className={getClassNameModern(cookieBlockClasses, 'clickablePrimary', 'btn btn-primary')}
            >{i18next.t('cookies:cookiebarShowCookiebar')}</button>
          </div>
        </footer>
      </>
    )
  })
}

export const CookieBlockLayoutInner = (props: {
  children?: React.ReactNode,
}): JSX.Element => {
  const { children } = props

  return (
    <div className={getClassNameModern(cookieBlockClasses, 'inner', 'mw-container-s mx-auto px-gutter')}>{children}</div>
  )
}
